export default __webpack_public_path__ + "static/media/ic_Calendar.9d0c7a06.svg";